export const shareReplayComponentConfig = {
  bufferSize: 1,
  refCount: true,
};

export const FACILITY_ID = 'FACILITY_ID';
export const TRAILER_ID = 'TRAILER_ID';
export const LOAD_ID = 'LOAD_ID';
